import type { UseQueryOptions } from "@pinia/colada";
import type { MaybeRefOrGetter } from "vue";

import { toValue } from "vue";

import { getEnv, handleQueryExpecting, kyNoCredentials } from "@solvari/utils";

function useCompanyCardQuery(
  customerId: MaybeRefOrGetter<string | null>,
  locale: MaybeRefOrGetter<Solvari.Common.Enums.LocaleEnum>,
) {
  return {
    key: () => ["company-card", toValue(customerId), toValue(locale)] as const,
    // 404: stale ?customerId link to a pro without profile → form renders without the card
    query: handleQueryExpecting(
      [{ status: 404, message: "Customer profile not found." }],
      () => {
        const id = toValue(customerId);
        if (!id) {
          throw new Error("useCompanyCardQuery called without a customerId");
        }
        return kyNoCredentials
          .get(
            `${getEnv().network.api}/v4/main-site/company-cards/${encodeURIComponent(id)}`,
            {
              searchParams: {
                localeCode: toValue(locale),
              } satisfies App.DTO.Customer.CompanyCardShowRequestDTO,
            },
          )
          .json<App.DTO.Customer.CompanyCardDTO>();
      },
    ),
    staleTime: 5 * 60 * 1000,
    enabled: () => !!toValue(customerId),
  } satisfies UseQueryOptions<App.DTO.Customer.CompanyCardDTO>;
}

export { useCompanyCardQuery };
